import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

/** Applique `?lang=fr|it` (et `language=`) à l’état UI i18n, pour SPA sans SSR. */
function LangQuerySync() {
  const location = useLocation();
  const { setLanguage } = useLanguage();

  useEffect(() => {
    try {
      const params = new URLSearchParams(location.search);
      const q = params.get('lang') || params.get('language') || '';
      const normalized = q.toLowerCase().trim();
      if (normalized === 'it' || normalized === 'fr') setLanguage(normalized);
    } catch {
      /* ignore */
    }
  }, [location.search, setLanguage]);

  return null;
}

export default LangQuerySync;
